import * as React from 'react'
import { styled } from 'next-yak'

import * as S from '../styles'

export type PlaceholderWithActionProps = React.HTMLAttributes<HTMLLabelElement> & {
  className?: string
  clickTarget?: string
}

function PlaceholderWithActionComponent({
  children,
  clickTarget,
  className,
  ...rest
}: PlaceholderWithActionProps): React.ReactElement<any> {
  return (
    <S.placeholder.Label className={className} htmlFor={clickTarget} {...rest}>
      {children}
    </S.placeholder.Label>
  )
}

export const PlaceholderWithAction = styled(PlaceholderWithActionComponent)``
